import { useMemo } from "react";
import { generatePath, useNavigate } from "react-router-dom";

import {
  DefaultButton,
  ShimmeredDetailsListProps,
  Stack,
  Text
} from "@bps/fluent-ui";
import { DataTable, DataTableColumn } from "@components/tables/DataTable";
import { OpsReportDefinition } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.dtos";

import { FMReport } from "./";
import { RefreshReportButton } from "./RefreshReportButton";

export interface FmReportsTableProps extends ShimmeredDetailsListProps {}

export const FmReportsTable = ({ ...props }: FmReportsTableProps) => {
  const navigate = useNavigate();

  const columns: DataTableColumn<FMReport>[] = useMemo(() => {
    return [
      {
        key: "name",
        name: "Name",
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isSorted: true,
        sort: true,
        onRender: (report: OpsReportDefinition) => (
          <Stack
            wrap
            styles={{
              root: { whiteSpace: "initial" }
            }}
          >
            <Text>{report.name}</Text>
          </Stack>
        )
      },
      {
        key: "viewReport",
        name: "",
        minWidth: 320,
        maxWidth: 320,
        isResizable: true,
        isSorted: true,
        sort: true,
        onRender: (report: OpsReportDefinition) => {
          const viewReport = e => {
            e.preventDefault();
            const to = generatePath("/system/plt/fm-reports/:reportName", {
              reportName: report.name
            });
            navigate(to);
          };

          return (
            <Stack
              horizontal
              tokens={{ childrenGap: 8 }}
              wrap
              styles={{
                root: { whiteSpace: "initial" }
              }}
            >
              <DefaultButton
                onClick={viewReport}
                styles={{
                  root: { width: 150 }
                }}
              >
                View Report
              </DefaultButton>
              <RefreshReportButton report={report} />
            </Stack>
          );
        }
      }
    ];
  }, [navigate]);

  return (
    <DataTable
      stickyHeader
      shimmerLines={10}
      columns={columns}
      onShouldVirtualize={() => true}
      {...props}
    />
  );
};
